function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRiconciliabile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.9 51.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M39.97,5.72c-4.02-2.88-8.94-4.57-14.26-4.57C12.14,1.15,1.15,12.16,1.15,25.74s11,24.59,24.56,24.59,24.56-11.01,24.56-24.59c0-5.64-1.9-10.84-5.09-14.99",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "50.76 9.64 43.61 9.64 43.61 16.79",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRiconciliabile);
export default __webpack_public_path__ + "static/media/ico-riconciliabile.e845486ebdb3fbdc5689958ce7eaae0d.svg";
export { ForwardRef as ReactComponent };